import { withModalProvider } from "../../hoc/withModalProvider";
import { LeaveRoommateGroupButton as View } from "./LeaveRoommateGroupButton";

export const LeaveRoommateGroupButton = withModalProvider(View);
